import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import './style.scss';

export const KTBSDropdownDirections = {
  left: 'dropleft',
  up: 'dropup',
  right: 'dropright',
  down: 'dropdown',
};

export const KTBSDropdownAlignments = {
  start: 'dropdown-menu-start',
  end: 'dropdown-menu-end',
};

export const KTBSDropdowAutoCloseBehavior = {
  true: 'true',
  false: 'false',
  inside: 'inside',
  outside: 'outside',
};

KTBSDropdown.propTypes = {
  toggleWrapperClassName: PropTypes.string,
  toggleElement: PropTypes.element,
  dropdownMenuClassName: PropTypes.string,
  dropdownMenuItems: PropTypes.array,
  selectedValue: PropTypes.string,
  direction: PropTypes.oneOf(Object.values(KTBSDropdownDirections)),
  alignment: PropTypes.oneOf(Object.values(KTBSDropdownAlignments)),
  offset: PropTypes.object,
  staticDisplay: PropTypes.bool, // on | off dynamic positioning
  autoCloseBehavior: PropTypes.oneOf(Object.values(KTBSDropdowAutoCloseBehavior)),
  contentEl: PropTypes.element,
  onChange: PropTypes.func,
};

KTBSDropdown.defaultProps = {
  toggleWrapperClassName: '',
  toggleElement: <></>,
  dropdownMenuClassName: '',
  dropdownMenuItems: [],
  selectedValue: null,
  direction: KTBSDropdownDirections.down,
  alignment: KTBSDropdownAlignments.start,
  offset: null,
  staticDisplay: true,
  autoCloseBehavior: KTBSDropdowAutoCloseBehavior.true,
  contentEl: null,
  onChange: null,
};

/**
 *
 * @param {{
 * toggleWrapperClassName: string,
 * toggleElement: element,
 * dropdownMenuClassName: string,
 * dropdownMenuItems: object[],
 * selectedValue: string,
 * direction: string,
 * alignment: string,
 * offset: {},
 * staticDisplay: boolean,
 * autoCloseBehavior: boolean,
 * contentEl: element,
 * onChange: function,
 * }} props
 * @returns
 */
function KTBSDropdown(props) {
  // MARK: --- Params ---
  const {
    toggleWrapperClassName,
    toggleElement,
    dropdownMenuClassName,
    dropdownMenuItems,
    selectedValue,
    direction,
    alignment,
    offset,
    staticDisplay,
    autoCloseBehavior,
    contentEl,
    onChange,
  } = props;
  const currentSelectedValue = useRef(selectedValue);
  const [autoCloseMode, setAutoCloseMode] = useState(autoCloseBehavior);

  useEffect(() => {
    setAutoCloseMode(autoCloseBehavior);
  }, [autoCloseBehavior]);

  return (
    <div className={`KTBSDropdown ${direction}`}>
      {/* Toggle element */}
      {staticDisplay ? (
        <div
          className={`${toggleWrapperClassName} ${direction}`}
          data-bs-toggle="dropdown"
          data-bs-display="static"
          aria-expanded="false"
          data-bs-auto-close={autoCloseMode}
        >
          {toggleElement}
        </div>
      ) : (
        <div
          className={`${toggleWrapperClassName} ${direction}`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close={autoCloseMode}
        >
          {toggleElement}
        </div>
      )}

      {/* Dropdown menu */}
      <div className={`dropdown-menu ${dropdownMenuClassName} ${alignment} p-2`}>
        {!_.isEmpty(contentEl) ? (
          <div>{contentEl}</div>
        ) : (
          <div>
            {dropdownMenuItems.map((item, index) => {
              return (
                <div key={index}>
                  <a
                    className={`dropdown-item ${
                      selectedValue === item.value && 'active'
                    } d-flex align-items-center justify-content-between gap-3 ${
                      index < dropdownMenuItems.length - 1 ? 'mb-2' : ''
                    }`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      currentSelectedValue.current = item.value;
                      if (onChange) {
                        onChange(currentSelectedValue.current);
                      }
                      if (item.onPress && _.isFunction(item.onPress)) {
                        item.onPress();
                      }
                    }}
                  >
                    <div className="d-flex align-items-center">
                      {item.icon && (
                        <i
                          className={`${item.icon} mr-2 min-w-20px`}
                          style={{
                            color: 'inherit',
                          }}
                        />
                      )}{' '}
                      {item.name}
                    </div>
                    {selectedValue === item.value && (
                      <i className="fa-regular fa-check text-primary" />
                    )}
                  </a>
                  {item.showDivider && <div className="dropdown-divider"></div>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default KTBSDropdown;
